import { useState, useEffect } from 'react';

import { servAssociaCpfRole, servGetRolesPorCpf, servDesassociaCpfRole } from '../../servicos/servicosEmRotasPrivadas/cpf_role';

import menosIcon from '../../imagens/minus.png'
import maisIcon from '../../imagens/plus-sign.png'

import toast from 'react-hot-toast';
import BarraBuscaCpf from '../BarraBuscaCpf';
import TituloSessao from '../TituloSessao';
import smartToast from '../../util/smart_toast';
import { formatCPF, toastErrorFromResponse } from '../../util/utilitarios';

function ModalAssociaRoleCpf() {

    console.log('### Iniciando ModalAssociaRoleCpf ###');

    const [roles, setRoles] = useState(null)
    const [cpf, setCpf] = useState(null)

    useEffect(() => {
        if (cpf) buscaRolesCpf();
    }, [cpf]);

    const buscaRolesCpf = async () => {
        try {

            const rolesDaApi = await toast.promise(
                servGetRolesPorCpf(cpf),
                { loading: 'Buscando permissões associadas ao CPF...' }
            )
            setRoles(rolesDaApi.data);

        } catch (error) {
            setRoles(null);
            toastErrorFromResponse(error);
        }
    }

    const associaCpfRole = async (roleId) => {

        try {

            const associao = { cpf: cpf, roleId: roleId }

            await toast.promise(
                servAssociaCpfRole(associao),
                { loading: 'Associando CPF...' }
            )

            buscaRolesCpf()

        } catch (error) {
            toastErrorFromResponse(error);
        }
    }

    const desassociaCpfRole = async (cpfRoleId) => {

        try {

            await smartToast(
                servDesassociaCpfRole(cpfRoleId),
                { loadingMessage: 'Desassociando CPF...' }
            );

            buscaRolesCpf()

        } catch (error) {
            toastErrorFromResponse(error);
        }
    }


    return (
        <div className="d-flex justify-content-center mt-3">
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                Associar
            </button>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content p-3">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Associar CPF à Permissão</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column flex-md-row gap-3">
                                <BarraBuscaCpf setRoles={setRoles} setCpfPai={setCpf} />
                            </div>
                        </div>
                        {roles &&
                            <div>
                                {cpf && <TituloSessao titulo={`CPF ${formatCPF(cpf)}`} barraDecorativa={false} />}
                                <TituloSessao titulo='Permissões Associadas' barraDecorativa={false} />
                                <ul className="list-group">
                                    {roles.roles_associadas.map((role) =>
                                        <li key={role.relacao_cpf_role_id}
                                            className="list-group-item d-flex justify-content-between">{role.nome_exibicao}
                                            <img
                                                className='minusAndPlusIcon'
                                                style={{ 'width': '1.5em' }}
                                                alt='icone de diminuicao'
                                                src={menosIcon}
                                                onClick={() => desassociaCpfRole(role.relacao_cpf_role_id)}
                                            />
                                        </li>

                                    )}
                                </ul>
                                <TituloSessao titulo='Associar Permissões' barraDecorativa={false} />
                                <ul className="list-group">
                                    {roles.roles_nao_associadas.map((role) =>
                                        <li key={role.role_id}
                                            className="list-group-item d-flex justify-content-between">{role.nome_exibicao}
                                            <img
                                                className='minusAndPlusIcon'
                                                style={{ 'width': '1.5em' }}
                                                alt='icone de diminuicao'
                                                src={maisIcon}
                                                onClick={() => associaCpfRole(role.role_id)}
                                            />
                                        </li>

                                    )}
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAssociaRoleCpf